import React from "react";
import chatRenderStyle from "./ChatNodeStyle.module.css";

export default function QNAHistory({ history, currentAnswer }) {
  return (
    <div className={chatRenderStyle.history_pre}>
      <h2 className={chatRenderStyle.hardcode_text}>
        We're here to help. What would you like to do?
      </h2>
      {history.length > 0 ? (
        <div>
          {history.map((entry, index) => (
            <div key={index}>
              <p>{entry}</p>
            </div>
          ))}
        </div>
      ) : null}

      {currentAnswer && (
        <div className={chatRenderStyle.his_ans}>
          <p>{currentAnswer}</p>
        </div>
      )}
    </div>
  );
}
